<template>
  <div class="page container-fluid h-100">
    <div class="row no-gutters row-md-h-100">
      <div class="spec-img ksps-map col-12 col-md-6 col-lg-5 order-1 order-lg-0">
        <GmapMap
          :center="{lat:50.070123, lng:19.944638}"
          :zoom="16"
          :options="map_options"
          map-type-id="roadmap"
          style="width: auto; height: 100%"
        >
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="false"
            :draggable="false"
            @click="center=m.position"
            :icon="m.icon"
          />
        </GmapMap>
      </div>
      <div class="spec-content col-12 col-md-4 col-lg-6 ml-auto mr-auto order-0 order-lg-1 contact-content">
        <h3>
          STAWIARSKA STALA
          <br>Kancelaria Radców Prawnych spółka cywilna
        </h3>
        <p></p>
        <p>
ul. Szlak 77/222<br />
31 – 153 Kraków
</p>
<p>
NIP: <strong>6762538652</strong><br />
REGON: <strong>368585254</strong>
        </p>
        <div class="phones col">
          <div class="row" v-for="contact in contacts" :key="contact.name">
            <div class="w-auto mr-3">Telefon: </div>
            <div class="w-auto">
              <b-button @click="contact.show = true" v-if="!contact.show" class="btn-dark">Kliknij aby wyświetlić</b-button>
              <span v-if="contact.show">{{ contact.phone }}</span><br />
              {{ contact.name }}
            </div>
          </div>
        </div>
        <p></p>
        <p>
        Adres e-mail: sekretariat@kspskancelaria.pl
        </p>
        <contact-form />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Kontakt",
  data() {
    return {
      image: "/assets/Kariera.jpg",
      name: "Kontakt",
      contacts: [
        {name: "radca prawny Katarzyna Stawiarska", phone: "+48 697 587 129", show: false},
        {name: "radca prawny Przemysław Stala", phone: "+48 508 702 962", show: false},
      ],
      map_options: {
        disableDefaultUI: false,
        scrollwheel: false,
        styles: [
          {
            featureType: "water",
            stylers: [
              {
                visibility: "on"
              },
              {
                color: "#b5cbe4"
              }
            ]
          },
          {
            featureType: "landscape",
            stylers: [
              {
                color: "#efefef"
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#83a5b0"
              }
            ]
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#bdcdd3"
              }
            ]
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff"
              }
            ]
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e3eed3"
              }
            ]
          },
          {
            featureType: "administrative",
            stylers: [
              {
                visibility: "on"
              },
              {
                lightness: 33
              }
            ]
          },
          {
            featureType: "road"
          },
          {
            featureType: "poi.park",
            elementType: "labels",
            stylers: [
              {
                visibility: "on"
              },
              {
                lightness: 20
              }
            ]
          },
          {},
          {
            featureType: "road",
            stylers: [
              {
                lightness: 20
              }
            ]
          },
                    {
            featureType: "poi.business",
            stylers: [
              {
                visibility: 'off'
              }
            ]
          }
        ]
      },
      markers: [
        {
          position: { lat: 50.070123, lng: 19.944638 },
          icon: { url: "/assets/ikona-mapa.png" }
        }
      ]
    };
  }
};
</script>
<style>
.ksps-map {
  min-height: 30rem;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  font-weight: bold;
}
.page {
  padding: 0;
  margin: 0;
  overflow: hidden;
  min-height: 800px;
}
.spec-content {
  padding: 2rem 3rem;
}
.contact-content {
  font-family: "Enriqueta", serif;
  font-size: 1.7rem;
}

@media (min-width: 960px) {
  .spec-content {
    padding: 5rem 5rem;
  }
}
</style>